// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"J2-z","colorTextValue":"K2-z","swatches":"L2-z","collapseLink":"M2-z","isCollapsed":"N2-z","dropdown":"O2-z","disabled":"P2-z"};